import { AnimatePresence } from 'framer-motion';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { SidebarModal } from '../../../components';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import Spinner from '../../../components/common/Spinner';

import {
  PurchaseSteps,
  SubsctriptionTypes,
  UserAddress
} from '../Maeketplace.types';
import {
  purchaseGoldenCard,
  purchasePackage,
  purchaseSubscription,
  purchaseSubscriptionBundle,
  purchaseSuperSales,
  setPurchaseCardStep
} from '../Marketplace.actions';

import { PaymentMethod } from './PaymentMethod';
import { Success } from './Success';
import { Failed } from './Failed';
import axios from 'axios';
import PaymentPage from './PaymentPage';

interface PurchasePackageAndComboProps {
  selectedPackage: any;
  modal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
  userDiscountCodeId?: number | null;
}

declare global {
  interface Window {
    tmtPaymentModalSdk: any;
    tmtPaymentModalReady: () => void;
  }
}

export const PurchasePackageAndCombo = ({
  selectedPackage,
  setModal,
  modal
}: PurchasePackageAndComboProps) => {
  const [userAddress, setUserAddress] = useState<UserAddress>({
    address: '',
    city: '',
    country: '',
    countryCode: '',
    zipCode: ''
  });
  const dispatch = useAppDispatch();
  const { addHubLoading, step } = useAppSelector((state) => state.marketplace);
  const { loading } = useAppSelector((state) => state.settings);
  const { userInfo } = useAppSelector((state) => state.auth);

  const [email, setEmail] = useState(userInfo?.user?.email);

  const renderTitle = handleSidebarTitle(step);

  const handlePay = async () => {
    switch (selectedPackage.type) {
      case SubsctriptionTypes.TRAVEL_PACKAGES:
        return dispatch(
          purchasePackage({
            productId: selectedPackage.id,
            email
          })
        );
      case SubsctriptionTypes.SUBSCRIPTION:
        return dispatch(
          purchaseSubscription({
            productId: selectedPackage.id,
            email
          })
        );
      case SubsctriptionTypes.GOLDEN_CARD:
        return dispatch(
          purchaseGoldenCard({
            productId: selectedPackage.id,
            email
          })
        );
      case SubsctriptionTypes.SUBCRIPTION_BUNDLE:
        return dispatch(
          purchaseSubscriptionBundle({
            productId: selectedPackage.id,
            email
          })
        );

      case SubsctriptionTypes.SUPER_SALES:
        return dispatch(
          purchaseSuperSales({
            productId: selectedPackage.id,
            email
          })
        );
      default:
        break;
    }
  };

  const getUserPermanentAddress = async () => {
    const apiURL = process.env.REACT_APP_API_URL;
    const { data } = await axios.get(`${apiURL}/user/permanent-address`);

    setUserAddress(data?.data?.userAddress);
  };

  useEffect(() => {
    getUserPermanentAddress();
  }, []);

  return (
    <SidebarModal
      isOpen={modal}
      sidebarWidth={'600px'}
      setOpen={(v) => {
        setModal(v);
        dispatch(setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_METHOD }));
      }}
      title={renderTitle}>
      <AnimatePresence exitBeforeEnter>
        {(loading || addHubLoading) && <Spinner absolute transparent />}

        {step === PurchaseSteps.PAYMENT_METHOD && (
          <AnimatedTab key={PurchaseSteps.PAYMENT_METHOD}>
            <PaymentMethod
              selectedPackage={selectedPackage}
              userInfo={userInfo}
              handlePay={handlePay}
              userAddress={userAddress}
              setEmail={setEmail}
              email={email}
            />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.PAYMENT_PAGE && (
          <AnimatedTab key={PurchaseSteps.PAYMENT_PAGE}>
            <PaymentPage selectedPackage={selectedPackage} />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.SUCCESS && (
          <AnimatedTab key={PurchaseSteps.SUCCESS}>
            <Success />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.FAILED && (
          <AnimatedTab key={PurchaseSteps.FAILED}>
            <Failed />
          </AnimatedTab>
        )}
      </AnimatePresence>
    </SidebarModal>
  );
};

const handleSidebarTitle = (step: PurchaseSteps) => {
  const { t } = useTranslation('marketplace');

  switch (step) {
    case PurchaseSteps.PAYMENT_METHOD:
      return t('select_package');
    case PurchaseSteps.PAYMENT_PAGE:
      return 'Payment Page';
    case PurchaseSteps.SUCCESS:
      return 'Payment Instructions';
    case PurchaseSteps.FAILED:
      return 'Payment Failed';
    default:
      return '';
  }
};
